import { Outlet } from "react-router-dom"

export const NoLayout = () => {

  return <Outlet />
}